import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from 'infrastructure/common/model/api.mutation';

export interface UpdateUserGrantNewsLetterParams {
	readonly grantNewsLetter: boolean;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserGrantNewsLetterApiMutation extends ApiMutation<
	void,
	UpdateUserGrantNewsLetterParams
> {
	client = 'messaging';
	document = gql`
		mutation UpdateUserGrantNewsLetter($grantNewsLetter: Boolean!) {
			updateUserGrantNewsLetter(grantNewsLetter: $grantNewsLetter)
		}
	`;
	method = 'updateUserGrantNewsLetter';
}
